import { resource } from "./resource";
import { getActiveLegalUnitId } from "./globalData";

const api = resource("/designation");

/**
 * Designations for the legal entity being worked in, plus any belonging to the
 * whole organisation.
 *
 * Was the org-wide list. With 17 designations under one entity and none under
 * the other, the second entity showed the first entity's — two companies under
 * one organisation appearing to share their job titles.
 *
 * Falls back to the org-wide read when no entity is selected, which is the
 * state an organisation is in before its first entity exists.
 */
export const getDesignations = async () => {
  const legalUnit = getActiveLegalUnitId();
  return legalUnit ? await api.get(`/legal-unit/${legalUnit}`) : await api.get();
};

// The whole organisation regardless of entity, for the rare caller that wants
// it. Kept separate rather than as a flag so the default is the scoped one.
export const getAllDesignations = async () => await api.get();

// { name, legalUnit? }
export const createDesignation = async (input = {}) => await api.post("", input);

export const updateDesignation = async (id, input = {}) => await api.put(`/${id}`, input);

// soft delete (PUT /designation/delete/:id)
export const deleteDesignation = async (id) => await api.put(`/delete/${id}`);
